import { createContext } from "react";

const supportContext = createContext({
  mode: null,
  guest: null,
  meta: null,
  summary: null,
  unread: 0,
  revision: 0,
  lastEvent: null,
  refreshSummary: () => null,
  reloadMeta: () => null,
});

export default supportContext;
